import React, {createContext, useContext, useState} from 'react';
import mazadat from "../images/projects/mazadat.JPG"
import realestateclub from "../images/projects/realestateclub.PNG"
import hololconsultingClub from "../images/projects/WhatsApp Image 2026-05-02 at 2.38.20 PM.jpeg"
import mediaprojects from "../images/projects/mediaprojects.JPG"
import nahdetmasr from "../images/projects/nahdetmaser.JPG"
import familymarket from "../images/projects/familymarket.JPG"
import mediaacademy from "../images/projects/mediaacademy.JPG"
import channelcreation from "../images/projects/channelcreation.JPG"
import masrwael3alm from "../images/projects/masrwael3alm.JPG"
import mehanalanbiaa from "../images/projects/mehanalanbiaa.JPG"
import youtv from "../images/projects/youtv.JPG"
import hand from "../images/projects/hand.JPG"

import mazadatPdf from "../pdfs/mazadatPdf.pdf"
import realEstateClubPdf from "../pdfs/RealEstateClubPdf.pdf"
import realEstateClubPdfEn from "../pdfs/RealEstateClubPdfEn.pdf"
import hololConsultingPdf from "../pdfs/HololConsulting.pdf"
import hololConsultingPdfEn from "../pdfs/hololConsultingEn.pdf"

import mazadat1 from "../images/mazadat/mazadat1.jpg"
import mazadat2 from "../images/mazadat/mazadat2.jpg"
import mazadat4 from "../images/mazadat/mazadat4.jpg"
import mazadat5 from "../images/mazadat/mazadat5.jpg"
import mazadat6 from "../images/mazadat/mazadat6.jpg"
import mazadat7 from "../images/mazadat/mazadat7.jpg"
import mazadat8 from "../images/mazadat/mazadat8.jpg"
import mazadat9 from "../images/mazadat/mazadat9.jpg"
import mazadat11 from "../images/mazadat/mazadat11.jpg"


const LanguageContext = createContext();


export const translations = {
    en: {
        // Navigation
        nav: {
            home: 'Home',
            services: 'Our Services',
            works: 'Our Works',
            projects: 'Our Projects',
            experience: 'Experience',
            quotes: 'Quotes',
            partners: 'Success Partners',
            videos: 'Videos',
            contact: 'Contact Us',
        },
        // Hero Section
        hero: {
            welcome: 'Welcome with us in ...',
            brand: 'Banan Integrated Solutions',
            sloganPrefix: 'Solutions',
            sloganSuffix: 'Without End',
        },
        // Services Section
        services: {
            title: 'Banan Integrated Solutions ...',
            titleHighlight: 'is the Solution',
            aboutTitle: 'Banan Integrated Solutions in Lines',
            aboutText: 'Banan is one of the companies specialized in providing innovative solutions in the field of media, real estate marketing, consulting and training. Examples include the Mazadat project, which is the largest media, developmental and marketing project presented in cooperation with the Egyptian CBC media channels group, and the Real Estate Club project as the largest media and marketing project in the field of real estate services worldwide, currently being implemented in cooperation with major companies around the world. Consulting and development services have also been provided to more than 850 companies in various fields.',
            skills: [
                {label: 'Media Projects', percent: 90},
                {label: 'Development', percent: 85},
                {label: 'Marketing', percent: 70},
                {label: 'Planning', percent: 60},
                {label: 'Training', percent: 50},
                {label: 'Consulting & Feasibility Studies', percent: 30},
                {label: 'Sales', percent: 40},
            ],
        },
        // Works Section
        works: {
            title: 'Know More About Us...',
            vision: 'Our Vision',
            visionText: 'A multi-disciplinary service company that provides new and innovative solutions suitable for different types of companies.',
            mission: 'Our Mission',
            missionText: 'Achieving leadership in the field of media, real estate development, training and consulting to be the first choice for all professionals and amateurs interested in this field.',
            goals: 'Our Goals',
            goalsItems: [
                'Providing diverse services that enhance the company\'s image worldwide',
                'Contributing to the development of various institutions as well as individuals',
                'Providing professional training programs and consulting services according to the latest scientific standards',
                'Conducting comprehensive assessment of institutions and their management',
            ],
            values: 'Corporate Values',
            valuesItems: [
                {
                    highlight: 'Cooperation and Sharing',
                    text: 'with various entities to provide distinguished services.'
                },
                {
                    highlight: 'Accuracy and Objectivity',
                    text: 'Making every effort to provide accurate content in various fields.'
                },
                {
                    highlight: 'Transparency and Credibility',
                    text: 'Observing transparency in dealing with all clients and adhering to international and legal practices.'
                },
                {
                    highlight: 'Creativity and Innovation',
                    text: 'Continuous development in providing services in a creative and innovative manner.'
                },
            ],
        },
        // Stats Section
        stats: {
            tradingVolume: 'Billion Trading Volume Through Mazadat Media Project',
            consultingCompanies: 'Companies Received Consulting in Various Fields',
            trainees: 'Trainees',
            realEstateUnits: 'Residential, Commercial and Administrative Units Marketed',
        },
        // Experience Section
        experience: {
            name: 'Dr. Adham Elsharkawy',
            subtitle: 'Professional and Academic Experience',
        },
        // Testimonials Section
        testimonials: {
            title: 'Quotes',
            subtitle: 'A Quote About Success',
            quotes: [
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj8Wy5jxJp79AnbHaHPyUIf64de27dMG4cL3tFiGS-GaMkawkYLYDQX6jyhQXsT2lIo82D1DWAZpraGsGFtfTgL8kkrYxgXzS9n8mtvjR-hHziKj-Dh-FR5qC3I1CLcwwa3_On7XD1rOxBEbDdGlH6GUXerU4a8CjwO1wy_JvNM1QlftRrZHA6_RHl5vBWC/s320/getty_495142964_198701.jpg',
                    text: 'A person\'s sincere will is like a hidden power that walks behind them, pushing them forward on the path to success... and grows over time until it prevents them from stopping or retreating.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh3Swy4aEjMhO6tbODJnhyphenhypheng1tT-QrDLVlNFDmiw3c6N3ptnrYb6uDYUll3nlHjja6fF1EMp8MEvKxMYMwpCfXIJe-avunwb7H7o7iczw6SXh4hdgalnOw_2-eNbu-A84WTbDi2CfwdkGgJ3grNjG_8h_Z8Zo5GHF44GbiozBbH7UOwdkEj8cRRm4LNjMSei/s320/BV-Acharya-5.jpg',
                    text: 'You only truly lose if you stop trying. Success has nothing to do with what you earn or achieve for yourself. Success is what you do for others.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi82FEJ36i7mSVog2fF59FQn_x_tSN1_LHq2jmrTJA71jgie4wjoOmyqm7dVv9qmhnlUPovHzhRLultmZFB5d0chq2URwcO5FM1yCOT_Zee2gkh54j5SEnJmTO5rme6_PBFyIjdhEdyqvKA2dw7xlfF1x7ne9pHnbIn_VDSlO3yLp2xRNjiHijNqvFUoxVB/s320/Gold-cup-winner-627253912-e1512101492156.jpg',
                    text: 'Resolve and strive, if you proceed, don\'t stop.. Be patient and persevere, success is certain. Patience is the key to success, and we have not found anything difficult that cannot be achieved without patience.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEidQYA9ZEmZhv3RfH-2e8PphEye7s0dXAb6cAvoDYQgh4cXx4kOO47E6LCWkcb-zXMKCH1MD9q9BkpEaeLpo4NWCPf_ilAUwT4kZsAE5P1nNNnpn6q64WfEd6MPJnQqdZ218ccPQG3LWUZSBeVhCSve53kCSxzxOHHH24vmUZ8qLFDVlCOXfgUgusbm4RYM/s900/success.jpg',
                    text: 'The only answer to defeat is victory. The hardest part of success is that you have to maintain it. Talent is just a starting point in the business world, and you must continue to develop and benefit from this talent.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjYq5dkPnOs8C0eMYMyI1RNX9kU3vvoNVpuTlAckytTKe1WgE0qAMkvdu9nlQXyZzRsvCcgU8c4tL3tkubTxQYArRrnNslyZQlQoxg7SCEuVbX9OGiV7CSLAJtTT5EU_v6khV2QNrpsInLpfWyoYuFwMaMgZhdi2acum04gLWWP0kR4_Yaz79Va49LqYlsV/s320/r0_0_6000_4000_w1200_h678_fmax.jpg',
                    text: 'Glory, success and production remain sweet dreams in the souls of their owners, and they do not become living realities unless the workers breathe their spirit into them and connect them with the sense and movement in the world.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEisngonmVSxhDi7vEhqnpVYshFc80MqNba82uJalgYMDrLlIhNg46BEdR_1ymR8PIokN7r8Ol7972W5gXM9QHto_tRohV_8tZvoizp53we65btvJqHYidm89IncMbFMfC4Qp_1VkUrbVkQigp9zsZnYbTbeZTCZy27mMlc5mWImH4hiFgdPukZKvVYRLfz4/s320/img20201119_Proctor_Wellbeing_Success.jpg',
                    text: 'When I was young, I noticed that nine out of ten things I do fail, so I did ten times what I had to do. Success is moving from failure to failure without losing hope.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhTsjU4dd1etL53YmCH6VpeV0eMPBKnp12V6OmEQhgyja7E3vwpAT6ndLJz7pfbFqg_5JUxDatkh1b7mt5DskMQ3esxtOVFhan9yBpMvRe2wbraFxdSkFKLc0pIh9OJ5aQWEUddM_Wr1CD2KcN3bnuwcUyWWQXrEe0tB7yq4FbrZlZ8-0ybT-5gDvB92fG1/s320/success-is-more-subjective-rather-objective-1505655445-1512.jpg',
                    text: 'You are not lazy, but you have helpless goals. Fear of any new attempt is an inevitable path to failure. The failure of those around you does not necessarily mean your failure, but do not expect them to help you succeed.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh30wy1dx8ivy_iJvPjVYEp_v90TKblSODN-CkLpzHNEiUH11GxNpTD1KuBQI-n5twM4_jKqsMw2oQG-9wl1lmPk_GC6e5N5O-Ju7YOWE7Fv52deoJJgjvqlI0NgfPAw3znRw31JTE_dVg8fdrwn6xPaIabonp9GjCcBdTiDF6w_uoiAnjbr4pNS-OGULzc/s320/Success%20(1).jpg',
                    text: 'The journey to success does not require searching for new land, but it requires attention to success, the desire to achieve it, and looking at things with new eyes.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjgQG-FT-GYcpKyoJM0Yg2KT0bgLd5UCCUKm0fuHrgHou0HQ-DWN5sVHmA4p-f_EicrXXxPq98_wIm5w7Gc2awfSx5WXPe8LiQRL-gLj3g017kx5Cd_EdRzAbS17pziWfLzbuawxFc211WbkiEdUi-sVporNMMRq-Y8rAyvewyahoSMNIRKrJBC1gDqOkuD/s320/l_fld59_success-adobestock_82256170-web-1.jpg',
                    text: 'Whenever success emerges as a result of good planning and continuous perseverance combined with the right opportunity, people consider it luck. Perseverance and success are twins, the first is a matter of quality and the second is a matter of time.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjkRC-4jcdNxNiYnABZ_9tqpHPXE5zAGUyGfQg_2Cs_EJeuuMydrR77zOzBDXFEkKwjdj_Yhop5FKVlp_q7oRD3V4mYJLPH1ckpIMfHNIUMKelYG88v7Q1YaPdVMIuse2dTeK6RHZoanLuVyo0XS3sMLHEV9jVRjprihyCVxZ9RkxB_NhIC2uLMFRd7M0j1/s320/success%20(2).jpg',
                    text: 'You have to learn the rules of the game first, then you have to learn how to play better than others. If the true believer is found, all the reasons for success are found with him. Success is the only worldly judge of right and wrong.',
                },
            ],
        },
        // Projects Section
        projects: {
            title: 'Our Projects',
            subtitle: 'Developmental - Marketing - Media - Training - Service',
            items: [
                {
                    title: 'Mazadat Program',
                    description: 'The largest developmental media and marketing project in collaboration with the CBC channel group.',
                    category: '',
                    image: mazadat,
                    details: 'Mazadat is a pioneering media project that revolutionized the auction industry in Egypt. Through strategic partnerships with CBC channels, we created an innovative platform that combines media exposure with real estate and developmental marketing, reaching millions of viewers across the Arab world.\n  Dr. Adham Elsharkawy presented the Mazadat project in collaboration with the Egyptian CBC channel group. It is a developmental, economic, marketing, and real estate project with a social dimension. The trading volume through it reached more than 250 billion Egyptian pounds, including auctions of ministries, governorates, banks, business sector companies, private companies, and individuals. The first phase has been implemented, and negotiations are underway with some satellite channels and businessmen to launch the second phase, which includes Gulf Auctions, Auctions Exchange, Auctions Newspaper, Auctions Website, and the International Auctions Exhibition.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: true,
                    // Videos array - add YouTube URLs or video IDs
                    videos: [
                        {
                            url: 'https://www.youtube.com/watch?v=oKvHFoMNYcU',
                            title: 'Mazadat Program | Dr. Adham Elsharkawy, the creator of the Mazadat program, talks about the project'
                        },
                        {
                            url: 'https://www.youtube.com/watch?v=RdQ8c-B2XB8',
                            title: 'Mazadat Program | Dr. Adham Elsharkawy talks about highlighting bright spots in the Egyptian economy and marketing them through the Mazadat project'
                        }
                    ],
                    // Images array - add image paths
                    images: [
                        {src: mazadat1, title: ''},
                        {src: mazadat2, title: ''},
                        {src: mazadat4, title: ''},
                        {src: mazadat5, title: ''},
                        {src: mazadat6, title: ''},
                        {src: mazadat7, title: ''},
                        {src: mazadat8, title: ''},
                        {src: mazadat9, title: ''},
                        {src: mazadat11, title: ''},
                        // Add more images: { src: '/images/mazadat2.jpg', title: 'Project Phase 2' }
                    ],
                    // PDF path
                    pdf: mazadatPdf
                },
                {
                    title: 'Real Estate Club Project',
                    description: 'The largest media and marketing project in the field of real estate services worldwide.',
                    category: '',
                    image: realestateclub,
                    details: 'Dr. Adham Elsharkawy presents the Real Estate Club project, the first of its kind worldwide. Members receive more than 15 real estate services in one place, globally, with no commissions or intermediaries. Over a thousand international companies participate, along with major banks, global sports clubs, leading TV channels, and media organizations to enhance transparency and reach. Innovative solutions are used for sales, marketing, and delivering real estate services to energize the global real estate market.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: true,
                    videos: [
                        {
                            url: 'https://youtu.be/fmKqntOVqPw',
                            title: 'Video explaining the idea of the world\'s first Real Estate Club'
                        },
                        {url: 'https://youtu.be/uQlPAWsOHvs', title: 'The Real Estate Club idea'}
                    ],
                    images: [],
                    pdf: realEstateClubPdfEn
                },
                {
                    title: 'Holol Consulting Club',
                    description: 'The first digital franchise worldwide',
                    category: '',
                    image: hololconsultingClub,
                    details: 'holol Club is the preferred destination for entrepreneurs, where we combine legal, financial, and strategic expertise to accelerate your business growth at the heart of the global economy.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: true,
                    videos: [{
                        url: "https://www.youtube.com/watch?v=uqqNlIqGmMg",
                        title: "Holol Consulting Club | the first digital franchise in the world"
                    }],
                    images: [],
                    pdf: hololConsultingPdfEn
                },
                {
                    title: 'Media Projects',
                    description: 'Consulting and development for more than 850 companies in various fields.',
                    category: '',
                    image: mediaprojects,
                    details: 'Our media projects division has successfully provided consulting and development services to over 850 companies across diverse industries. We specialize in media strategy, content development, and digital transformation.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: mediaprojects, title: 'Media Projects'}],
                    pdf: null
                },
                {
                    title: 'You TV Project',
                    description: 'Consulting and development for more than 850 companies in various fields.',
                    category: '',
                    image: youtv,
                    details: 'You TV is an innovative digital television platform designed for the modern viewer. We provided comprehensive consulting on content strategy, technology implementation, and audience engagement.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: youtv, title: 'You TV'}],
                    pdf: null
                },
                {
                    title: 'Family Market Project',
                    description: 'Consulting and development for more than 850 companies in various fields.',
                    category: '',
                    image: familymarket,
                    details: 'Family Market is an innovative retail concept that brings together quality products and family values. Our consulting work has helped establish a unique market positioning and customer experience strategy.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: familymarket, title: 'Family Market'}],
                    pdf: null
                },
                {
                    title: 'Media Academy Project',
                    description: 'Consulting and development for more than 850 companies in various fields.',
                    category: '',
                    image: mediaacademy,
                    details: 'The Media Academy project established a premier educational institution dedicated to training the next generation of media professionals. Our comprehensive curriculum covers all aspects of modern media production and broadcasting.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: mediaacademy, title: 'Media Academy'}],
                    pdf: null
                },
                {
                    title: 'Satellite Channel Creation Project',
                    description: 'Consulting and development for more than 850 companies in various fields.',
                    category: '',
                    image: channelcreation,
                    details: 'This project involved the complete setup and launch of satellite television channels. From technical infrastructure to content strategy, we provided end-to-end solutions for establishing successful broadcast operations.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: channelcreation, title: 'Channel Creation'}],
                    pdf: null
                },
                {
                    title: 'Egypt and the World Project',
                    description: 'Consulting and development for more than 850 companies in various fields.',
                    category: '',
                    image: masrwael3alm,
                    details: 'Egypt and the World is a media initiative designed to showcase Egyptian culture, achievements, and opportunities to a global audience. Through compelling content and strategic partnerships, we bridge Egypt with the international community.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: masrwael3alm, title: 'Egypt and the World'}],
                    pdf: null
                },
                {
                    title: 'Professions of the Prophets Project',
                    description: 'Consulting and development for more than 850 companies in various fields.',
                    category: '',
                    image: mehanalanbiaa,
                    details: 'A unique educational media project exploring the various professions and skills attributed to the prophets in Islamic tradition. This project combines religious education with practical career guidance and inspiration.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: mehanalanbiaa, title: 'Professions of the Prophets'}],
                    pdf: null
                },

                {
                    title: 'Nahdet Masr Project',
                    description: 'Consulting and development for more than 850 companies in various fields.',
                    category: '',
                    image: nahdetmasr,
                    details: 'Nahdet Masr is a comprehensive development project focused on empowering Egyptian businesses and institutions. Through strategic consulting and innovative solutions, we help organizations achieve sustainable growth and success.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: nahdetmasr, title: 'Nahdet Masr'}],
                    pdf: null
                },
                {
                    title: 'A Hand Loved by God and His Messenger Project',
                    description: 'Consulting and development for more than 850 companies in various fields.',
                    category: '',
                    image: hand,
                    details: 'This inspirational project focuses on charitable work and community service, highlighting the importance of helping others as emphasized in Islamic teachings. It combines media production with social impact initiatives.',
                    copyright: 'Dr. Adham Elsharkawy is the owner of the intellectual and literary property of this project. No one may use this study or quote any part of it by copying, photographing, downloading, or altering its content without written permission from the exclusive rights holder, Dr. Adham Elsharkawy. Any violation of this right will result in legal accountability.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: hand, title: 'A Hand Loved by God'}],
                    pdf: null
                },
            ],
        },
        // Partners Section
        partners: {
            title: 'Success Partners',
            subtitle: 'Thank you to everyone who took a step with me towards success',
            items: [
                {
                    title: 'Dr. Adham Elsharkawy in the Successful Media Maker Course',
                    description: 'One of the Banan Media Training Center courses in cooperation with Al-Nas TV Channel.',
                },
                {
                    title: 'Journalist Youssef El-Husseiny in How to Become a Successful Broadcaster Course',
                    description: 'Dr. Adham Elsharkawy with the journalist and broadcaster Youssef El-Husseiny, presenter of the 9 PM program.',
                },
                {
                    title: 'Engineer Jasser Khorshid in How to Become a Successful Sound Engineer Course',
                    description: 'Dr. Adham Elsharkawy with Engineer Jasser Khorshid, one of the most famous Egyptian sound engineers.',
                },
                {
                    title: 'Mr. Nader Khalifa in How to Become a Successful Program Preparer Course',
                    description: 'Dr. Adham Elsharkawy with Mr. Nader Khalifa, author, art critic and screenwriter.',
                },
                {
                    title: 'Director Mr. Mohamed Donia in How to Become a Successful Director Course',
                    description: 'He has presented many famous TV works, most notably the This Evening program.',
                },
                {
                    title: 'Journalist and Writer Mr. Samir El-Gamal',
                    description: 'Dr. Adham Elsharkawy with the journalist and writer Mr. Samir El-Gamal, author of the movie 5-Star Thieves.',
                },
                {
                    title: 'Dr. Adham Elsharkawy with Governor of Alexandria Tarek Mahdi',
                    description: 'Signing a cooperation protocol to market the governorate\'s projects through the Mazadat program.',
                },
                {
                    title: 'Dr. Adham Elsharkawy with Governor of Beheira Mostafa Hadhood',
                    description: 'Signing a cooperation protocol to market the governorate\'s projects through the Mazadat program.',
                },
                {
                    title: 'Discussion About Usufruct Auctions',
                    description: 'Launching auctions with usufruct rights achieves significant economic returns.',
                },
            ],
        },
        // Videos Section
        videos: {
            name: 'Dr. Adham Elsharkawy',
            subtitle: 'Videos - Programs - Courses',
            items: [
                {
                    id: 'eklsLyv3sUc',
                    title: 'Dr. Adham Elsharkawy, founder and project manager of Mazadat program, talks about activating the project with Major General Tarek Mahdi, Governor of Alexandria'
                },
                {
                    id: '9QAPz42Du_0',
                    title: 'Dr. Adham Elsharkawy, founder and project manager of Mazadat program, talks about signing a cooperation protocol with Major General Mustafa Hadhoud, Governor of Beheira'
                },
                {
                    id: 'pYaVMrI69Yc',
                    title: 'Mazadat Newsletter: Dr. Adham Elsharkawy, founder and project manager of Mazadat, and the signing ceremony of a cooperation protocol with the Governor of Alexandria'
                },
                {
                    id: 'twMJxdxKsp4',
                    title: 'Various newsletter about auctions and Dr. Adham Elsharkawy, founder and project manager of Mazadat program, signs a cooperation protocol with Beheira Governorate'
                },
                {
                    id: 'WhdrABmvv1w',
                    title: 'Dr. Adham Elsharkawy, founder and project manager of Mazadat program, talks about the protocol signed with Alexandria Governorate which is not limited to marketing only but extends to follow-up'
                },
                {
                    id: 'RdQ8c-B2XB8',
                    title: 'Dr. Adham Elsharkawy talks about the goals of Mazadat project and how institutions and individuals can benefit from it, and how the national economy can benefit from it'
                },
                {
                    id: 'oKvHFoMNYcU',
                    title: 'Dr. Adham Elsharkawy, founder and project manager of Mazadat program, talks about the Mazadat project'
                },
                {
                    id: '_KbFgwCBU-Y',
                    title: 'Dr. Adham Elsharkawy, founder and project manager of Mazadat program, responds to viewers inquiries about Mazadat project and how to benefit from it'
                },
                {
                    id: 'DTRretawS5A',
                    title: 'Dr. Adham Elsharkawy, founder and project manager of Mazadat program, talks about coordinating with Alexandria Governorate to film all their auctions'
                },
                {
                    id: 'gYYh_0v_-ZI',
                    title: 'Dr. Adham Elsharkawy, founder and project manager of Mazadat program, talks about a group of auctions benefiting from Mazadat program with a group of expert appraisers'
                },
                {
                    id: 'iuPtbv0XLC8',
                    title: 'Dr. Adham Elsharkawy, founder and project manager of Mazadat program, talks about activating Mazadat project with Beheira Governorate soon'
                },
                {
                    id: 'ojJmI-bvhIA',
                    title: 'Dr. Adham Elsharkawy, founder and project manager of Mazadat program, talks about evaluating Mazadat project since its beginning, the problems and advantages'
                },
                {
                    id: 'ag_sP1sOwik',
                    title: 'Dr. Adham Elsharkawy, founder and project manager of Mazadat program, talks about the future plan for Mazadat project'
                },
                {
                    id: 'fmKqntOVqPw',
                    title: 'Brief explanation of the Real Estate Club idea, the first project of its kind in the world'
                },
            ],
        },
        // Contact Section
        contact: {
            title: 'Contact Us',
            subtitle: 'Contact us anytime and we will get back to you as soon as possible',
            form: {
                name: 'Name*',
                email: 'Email*',
                message: 'Message*',
                send: 'Send',
            },
            address: 'Address',
            addressValue: 'A1-210 / Kazan Plaza / Gamal Abdelnaser St. / 6 October - Giza',
            emailLabel: 'Email',
            emailValue: 'info@adhamelsharkawy.com',
            website: 'Website',
            websiteValue: 'www.adhamelsharkawy.com',
            successMessage: 'Thank you for contacting us! We will get back to you soon.',
        },
        // Footer
        footer: {
            home: 'Home',
            services: 'Our Services',
            works: 'Our Works',
            partners: 'Success Partners',
            contact: 'Contact Us',
            rights: 'All Rights Reserved © 2026 - Dr. Adham Elsharkawy',
        },
        // Social Media
        socialMedia: {
            facebook: 'https://www.facebook.com/dr.adhamelsharkaawy/',
            twitter: 'https://x.com/dradhambis',
            instagram: 'https://www.instagram.com/dr.adhamelsharkawy/',
            linkedin: 'https://www.linkedin.com/in/dr-adhamelsharkawy?utm_source=share_via&utm_content=profile&utm_medium=member_android',
            youtube: 'https://www.youtube.com/@adhamelsharkaawy',
            whatsapp: 'https://wa.me/+201004449782',
        },
    },
    ar: {
        // ...existing code...
        nav: {
            home: 'الرئيسية',
            services: 'خدماتنا',
            works: 'أعمالنا',
            projects: 'مشاريعنا',
            experience: 'الخبرات',
            quotes: 'مقولات',
            partners: 'شركاء النجاح',
            videos: 'فيديوهات',
            contact: 'اتصل بنا',
        },
        // Hero Section
        hero: {
            welcome: 'أهلًا بكم معنا في ...',
            brand: 'بنان للحلول المتكاملة',
            sloganPrefix: 'حلول',
            sloganSuffix: 'بلا نهاية',
        },
        // Services Section
        services: {
            title: 'بنان للحلول المتكاملة ...',
            titleHighlight: 'هي الحل',
            aboutTitle: 'بنان للحلول المتكاملة في سطور',
            aboutText: 'شركة بنان من الشركات المتخصصة في تقديم الحلول الابتكارية في مجال الإعلام والتسويق العقاري والاستشارات والتدريب ومنها على سبيل المثال مشروع مزادات وهو أضخم مشروع إعلامي تنموي وتسويقي تم تقديمه بالتعاون مع مجموعة قنوات CBC الإعلامية المصرية ومشروع النادي العقاري كأكبر مشروع إعلامي وتسويقي في مجال الخدمات العقارية على مستوى العالم وجاري تنفيذه حاليا بالتعاون مع كبرى الشركات في العالم وكذلك تم تقديم استشارات وتطوير شركات لأكثر من 850 شركة في مختلف المجالات.',
            skills: [
                {label: 'مشاريع إعلامية', percent: 90},
                {label: 'تطوير', percent: 85},
                {label: 'تسويق', percent: 70},
                {label: 'تخطيط', percent: 60},
                {label: 'تدريب', percent: 50},
                {label: 'استشارات ودراسات جدوي', percent: 30},
                {label: 'مبيعات', percent: 40},
            ],
        },
        // Works Section
        works: {
            title: 'تعرف علينا أكثر...',
            vision: 'رؤيتنا',
            visionText: 'شركة خدمية متعددة المجالات توفر حلول جديدة ومبتكرة تلائم مختلف أنواع الشركات.',
            mission: 'رسالتنا',
            missionText: 'تحقيق الريادة في مجال التطوير الإعلامي والعقاري والتدريب والاستشارات لنكون الخيار الأول لكافة المهتمين بهذا المجال من المحترفين والهواه على حد سواء.',
            goals: 'أهدافنا',
            goalsItems: [
                'تقديم خدمات متنوعة تعزز صورة الشركة في العالم',
                'المساهمة في تطوير مختلف المؤسسات وكذلك الأفراد',
                'تقديم برامج تدريبية احترافية وخدمات استشارية وفقا لأحدث المعايير العلمية',
                'عمل تقييم شامل للمؤسسات واداراتها',
            ],
            values: 'القيم المؤسسية للشركة',
            valuesItems: [
                {highlight: 'التعاون والمشاركة', text: 'مع مختلف الجهات لتقديم خدمات متميزة.'},
                {highlight: 'الدقة والموضوعية', text: 'بذل كل الجهد لتقديم محتوى دقيق في مختلف المجالات.'},
                {
                    highlight: 'الشفافية والمصداقية',
                    text: 'مراعاة الشفافية في التعامل مع جميع العملاء والالتزام بالممارسات الدولية والقانونية المرعية في ذلك.'
                },
                {highlight: 'الإبداع والابتكار', text: 'وهو التطوير المستمر في تقديم الخدمات بشكل مبدع ومبتكر.'},
            ],
        },
        // Stats Section
        stats: {
            tradingVolume: 'مليار حجم التداول من خلال مشروع مزادات الإعلامي',
            consultingCompanies: 'شركة حصلت على استشارات في مختلف المجالات',
            trainees: 'متدرب',
            realEstateUnits: 'تسويق وحدات سكنية وتجارية وإدارية',
        },
        // Experience Section
        experience: {
            name: 'دكتور أدهم الشرقاوي',
            subtitle: 'الخبرات العملية و العلمية',
        },
        // Testimonials Section
        testimonials: {
            title: 'مقولات',
            subtitle: 'مقولة عن النجاح',
            quotes: [
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj8Wy5jxJp79AnbHaHPyUIf64de27dMG4cL3tFiGS-GaMkawkYLYDQX6jyhQXsT2lIo82D1DWAZpraGsGFtfTgL8kkrYxgXzS9n8mtvjR-hHziKj-Dh-FR5qC3I1CLcwwa3_On7XD1rOxBEbDdGlH6GUXerU4a8CjwO1wy_JvNM1QlftRrZHA6_RHl5vBWC/s320/getty_495142964_198701.jpg',
                    text: 'الإرادة الصادقة للإنسان.. تشبه قوة خفية تسير خلف ظهره، وتدفعه دفعاً للأمام على طريق النجاح.. وتتنامى مع الوقت حتى تمنعه من التوقف أو التراجع.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh3Swy4aEjMhO6tbODJnhyphenhypheng1tT-QrDLVlNFDmiw3c6N3ptnrYb6uDYUll3nlHjja6fF1EMp8MEvKxMYMwpCfXIJe-avunwb7H7o7iczw6SXh4hdgalnOw_2-eNbu-A84WTbDi2CfwdkGgJ3grNjG_8h_Z8Zo5GHF44GbiozBbH7UOwdkEj8cRRm4LNjMSei/s320/BV-Acharya-5.jpg',
                    text: 'إنك لا تخسر حقاً إلا إذا توقفت عن المحاولة، لا علاقة للنجاح بما تكسبه في الحياة أو تنجزه لنفسك، فالنجاح هو ما تفعله للآخرين.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi82FEJ36i7mSVog2fF59FQn_x_tSN1_LHq2jmrTJA71jgie4wjoOmyqm7dVv9qmhnlUPovHzhRLultmZFB5d0chq2URwcO5FM1yCOT_Zee2gkh54j5SEnJmTO5rme6_PBFyIjdhEdyqvKA2dw7xlfF1x7ne9pHnbIn_VDSlO3yLp2xRNjiHijNqvFUoxVB/s320/Gold-cup-winner-627253912-e1512101492156.jpg',
                    text: 'اعتزم وكدّ فإن مضيت فلا تقف.. واصبر وثابر فالنجاح محقق، فالصبر مفتاح النجاح ولم نجد صعباً بغير الصبر يبلغه الأمل.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEidQYA9ZEmZhv3RfH-2e8PphEye7s0dXAb6cAvoDYQgh4cXx4kOO47E6LCWkcb-zXMKCH1MD9q9BkpEaeLpo4NWCPf_ilAUwT4kZsAE5P1nNNnpn6q64WfEd6MPJnQqdZ218ccPQG3LWUZSBeVhCSve53kCSxzxOHHH24vmUZ8qLFDVlCOXfgUgusbm4RYM/s900/success.jpg',
                    text: 'إن الإجابة الوحيدة على الهزيمة هي الانتصار، أصعب ما في النجاح أن عليك المحافظة عليه والموهبة هي مجرد نقطة بداية في عالم الأعمال، وعليك أن تداوم على تنمية هذه الموهبة والاستفادة منها.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjYq5dkPnOs8C0eMYMyI1RNX9kU3vvoNVpuTlAckytTKe1WgE0qAMkvdu9nlQXyZzRsvCcgU8c4tL3tkubTxQYArRrnNslyZQlQoxg7SCEuVbX9OGiV7CSLAJtTT5EU_v6khV2QNrpsInLpfWyoYuFwMaMgZhdi2acum04gLWWP0kR4_Yaz79Va49LqYlsV/s320/r0_0_6000_4000_w1200_h678_fmax.jpg',
                    text: 'إن المجد والنجاح والإنتاج تظل أحلاماً لذيذة في نفوس أصحابها وما تتحول حقائق حية إلا إذا نفخ فيها العاملون من روحهم ووصلوها بما في الدنيا من حس وحركة.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEisngonmVSxhDi7vEhqnpVYshFc80MqNba82uJalgYMDrLlIhNg46BEdR_1ymR8PIokN7r8Ol7972W5gXM9QHto_tRohV_8tZvoizp53we65btvJqHYidm89IncMbFMfC4Qp_1VkUrbVkQigp9zsZnYbTbeZTCZy27mMlc5mWImH4hiFgdPukZKvVYRLfz4/s320/img20201119_Proctor_Wellbeing_Success.jpg',
                    text: 'عندما كنت صغيراً، لاحظت أن تسعاً من كل عشرة أشياء أقوم بها تخفق، لذا قمت بعشرة أضعاف ما توجب علي عمله، النجاح هو الانتقال من فشل إلى فشل، دون أن نفقد الأمل.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhTsjU4dd1etL53YmCH6VpeV0eMPBKnp12V6OmEQhgyja7E3vwpAT6ndLJz7pfbFqg_5JUxDatkh1b7mt5DskMQ3esxtOVFhan9yBpMvRe2wbraFxdSkFKLc0pIh9OJ5aQWEUddM_Wr1CD2KcN3bnuwcUyWWQXrEe0tB7yq4FbrZlZ8-0ybT-5gDvB92fG1/s320/success-is-more-subjective-rather-objective-1505655445-1512.jpg',
                    text: 'لستم كسالى ولكن لديكم أهدافاً عاجزة، الخوف من أي محاولة جديدة طريق حتمي للفشل، فشل من حولك لا يعني بالضرورة فشلك، لكن لا تتوقع منهم مساعدتك على النجاح.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh30wy1dx8ivy_iJvPjVYEp_v90TKblSODN-CkLpzHNEiUH11GxNpTD1KuBQI-n5twM4_jKqsMw2oQG-9wl1lmPk_GC6e5N5O-Ju7YOWE7Fv52deoJJgjvqlI0NgfPAw3znRw31JTE_dVg8fdrwn6xPaIabonp9GjCcBdTiDF6w_uoiAnjbr4pNS-OGULzc/s320/Success%20(1).jpg',
                    text: 'رحلة النجاح لا تتطلب البحث عن أرض جديدة ولكنها تتطلب الاهتمام بالنجاح والرغبة في تحقيقه والنظر إلى الأشياء بعيون جديدة.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjgQG-FT-GYcpKyoJM0Yg2KT0bgLd5UCCUKm0fuHrgHou0HQ-DWN5sVHmA4p-f_EicrXXxPq98_wIm5w7Gc2awfSx5WXPe8LiQRL-gLj3g017kx5Cd_EdRzAbS17pziWfLzbuawxFc211WbkiEdUi-sVporNMMRq-Y8rAyvewyahoSMNIRKrJBC1gDqOkuD/s320/l_fld59_success-adobestock_82256170-web-1.jpg',
                    text: 'كلما لاح النجاح نتيجة التخطيط الجيد والمثابرة المستمرة مقرونين بالفرصة المواتية، اعتبر الناس ذلك حظاً، المثابرة والنجاح توأمان الأولى مسألة نوعية والثاني مسألة وقت.',
                },
                {
                    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjkRC-4jcdNxNiYnABZ_9tqpHPXE5zAGUyGfQg_2Cs_EJeuuMydrR77zOzBDXFEkKwjdj_Yhop5FKVlp_q7oRD3V4mYJLPH1ckpIMfHNIUMKelYG88v7Q1YaPdVMIuse2dTeK6RHZoanLuVyo0XS3sMLHEV9jVRjprihyCVxZ9RkxB_NhIC2uLMFRd7M0j1/s320/success%20(2).jpg',
                    text: 'عليك أن تتعلم قواعد اللعبة أولاً، ثم عليك أن تتعلم كيف تلعب أفضل من الآخرين، إذا وُجد المؤمن الصحيح وُجدت معه أسباب النجاح جميعاً، النجاح هو القاضي الدنيوي الوحيد للصواب والخطأ.',
                },
            ],
        },
        // Projects Section
        projects: {
            title: 'مشاريعنا',
            subtitle: 'تنموية - تسويقية - إعلامية - تدريبية - خدمية',
            items: [
                {
                    title: 'برنامج مزادات',
                    description: 'أضخم مشروع إعلامي تنموي وتسويقي بالتعاون مع مجموعة قنوات CBC.',
                    category: '',
                    image: mazadat,
                    details: 'مزادات هو مشروع إعلامي رائد أحدث ثورة في صناعة المزادات في مصر. من خلال الشراكات الاستراتيجية مع قنوات CBC، أنشأنا منصة مبتكرة تجمع بين الإنتشار الإعلامي والتسويق العقاري والتنموي، ونصل إلى ملايين المشاهدين في جميع أنحاء العالم العربي.\n  دكتور / أدهم الشرقاوي قدم مشروع مزادات  بالتعاون مع مجموعة قنوات CBC المصرية وهو مشروع تنموي اقتصادي تسويقي عقاري له بعد اجتماعي وصل حجم التداول من خلاله إلى أكثر من 250 مليار جنيه شاملة مزادات الوزارات والمحافظات والبنوك وشركات قطاع الأعمال والشركات الخاصة والأفراد، تم تنفيذ المرحلة الأولى منه وجاري التفاوض مع بعض القنوات الفضائية وبعض رجال الأعمال لعمل المرحلة الثانية منه وهو مزادات الخليج وبورصة المزادات وجريدة مزادات وموقع مزادات والمعرض الدولي للمزادات.',

                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: true,
                    videos: [
                        {
                            url: 'https://www.youtube.com/watch?v=oKvHFoMNYcU',
                            title: '- برنامج مزادات | دكتور أدهم الشرقاوي صاحب فكرة برنامج مزادات يتحدث عن المشروع'
                        },
                        {
                            url: 'https://www.youtube.com/watch?v=RdQ8c-B2XB8',
                            title: '- برنامج مزادات | دكتور أدهم الشرقاوي يتحدث عن التركيز على النقاط المضيئة في الاقتصاد المصري وتسويقها من خلال مشروع مزادات'
                        }
                    ],
                    images: [
                        {src: mazadat1, title: ''},
                        {src: mazadat2, title: ''},
                        {src: mazadat4, title: ''},
                        {src: mazadat5, title: ''},
                        {src: mazadat6, title: ''},
                        {src: mazadat7, title: ''},
                        {src: mazadat8, title: ''},
                        {src: mazadat9, title: ''},
                        {src: mazadat11, title: ''},
                    ],
                    pdf: mazadatPdf
                },
                {
                    title: 'مشروع النادي العقاري',
                    description: 'أكبر مشروع إعلامي وتسويقي في مجال الخدمات العقارية على مستوى العالم.',
                    category: '',
                    image: realestateclub,
                    details: ' دكتور/أدهم الشرقاوي يتحدث عن مشروع النادي العقاري وهو المشروع الأول من نوعه في هذا المجال على مستوى العالم يحصل العضو المشترك في النادي على أكثر من 15 خدمة عقارية من خلال مكان واحد على مستوى العالم بدون عمولات ولا وسطاء ويشارك في هذا المشروع أكثر من ألف شركة عالمية تتميز بتقديم أفضل الخدمات العقارية وبمشاركة كبرى المؤسسات البنكية والنوادي الرياضية العالمية وكذلك كبرى القنوات التلفزيونية والهيئات الإعلامية لإضفاء الشفافية والانتشار ويتم استخدام حلول ابتكارية للبيع والتسويق وتقديم الخدمات العقارية لتنشيط السوق العقاري العالمي.',
                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: true,
                    videos: [
                        {
                            url: 'https://youtu.be/fmKqntOVqPw',
                            title: 'فيديو لشرح فكرة النادي العقاري الأول من نوعه في العالم'
                        },
                        {url: 'https://youtu.be/uQlPAWsOHvs', title: 'فكرة النادي العقاري'}
                    ],
                    images: [],
                    pdf: realEstateClubPdf
                },
                {
                    title: 'نادي حلول للاستشارات',
                    description: 'اول فرنشايز رقمي في العالم.',
                    category: '',
                    image: hololconsultingClub,
                    details: 'نادي حلول هو الوجهة المفضلة لرواد الأعمال، حيث نجمع بين الخبرة القانونية والمالية والاستراتيجية لدفع نمو أعمالك في قلب الاقتصاد العالمي.',
                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: true,
                    videos: [{
                        url: "https://youtu.be/dO01G-k37WU",
                        title: "فكرة نادي حلول للاستشارات | أول فرنشايز رقمي في العالم"
                    }],
                    images: [],
                    pdf: hololConsultingPdf
                },
                {
                    title: 'المشروعات الاعلامية',
                    description: 'تقديم استشارات وتطوير لأكثر من 850 شركة في مختلف المجالات.',
                    category: '',
                    image: mediaprojects,
                    details: 'قدم قسم المشاريع الإعلامية لدينا بنجاح خدمات استشارية وتطويرية لأكثر من 850 شركة في صناعات متنوعة. نحن متخصصون في الاستراتيجية الإعلامية وتطوير المحتوى والتحول الرقمي.',
                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: mediaprojects, title: 'المشروعات الاعلامية'}],
                    pdf: null
                },
                {
                    title: 'مشروع يو تي في',
                    description: 'تقديم استشارات وتطوير لأكثر من 850 شركة في مختلف المجالات.',
                    category: '',
                    image: youtv,
                    details: 'يو تي في هي منصة تلفزيونية رقمية مبتكرة مصممة للمشاهد الحديث. قدمنا استشارات شاملة حول استراتيجية المحتوى وتنفيذ التكنولوجيا ومشاركة الجمهور.',
                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: youtv, title: 'يو تي في'}],
                    pdf: null
                },
                {
                    title: 'مشروع فاملي ماركت',
                    description: 'تقديم استشارات وتطوير لأكثر من 850 شركة في مختلف المجالات.',
                    category: '',
                    image: familymarket,
                    details: 'فاملي ماركت هو مفهوم تجزئة مبتكر يجمع بين المنتجات عالية الجودة والقيم العائلية. ساعد عملنا الاستشاري في إنشاء موقع سوقي فريد واستراتيجية تجربة العملاء.',
                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: familymarket, title: 'فاملي ماركت'}],
                    pdf: null
                },
                {
                    title: 'مشروع الأكاديمية الإعلامية',
                    description: 'تقديم استشارات وتطوير لأكثر من 850 شركة في مختلف المجالات.',
                    category: '',
                    image: mediaacademy,
                    details: 'أنشأ مشروع الأكاديمية الإعلامية مؤسسة تعليمية رائدة مكرسة لتدريب الجيل القادم من المحترفين الإعلاميين. يغطي منهجنا الشامل جميع جوانب الإنتاج الإعلامي الحديث والبث.',
                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: mediaacademy, title: 'الأكاديمية الإعلامية'}],
                    pdf: null
                },
                {
                    title: 'مشورع انشاء قناة فضائية',
                    description: 'تقديم استشارات وتطوير لأكثر من 850 شركة في مختلف المجالات.',
                    category: '',
                    image: channelcreation,
                    details: 'تضمن هذا المشروع الإعداد الكامل وإطلاق قنوات التلفزيون الفضائي. من البنية التحتية التقنية إلى استراتيجية المحتوى، قدمنا حلولاً شاملة لإنشاء عمليات بث ناجحة.',
                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: channelcreation, title: 'انشاء قناة فضائية'}],
                    pdf: null
                },
                {
                    title: 'مشروع مصر و العالم',
                    description: 'تقديم استشارات وتطوير لأكثر من 850 شركة في مختلف المجالات.',
                    category: '',
                    image: masrwael3alm,
                    details: 'مصر والعالم هي مبادرة إعلامية مصممة لعرض الثقافة والإنجازات والفرص المصرية على جمهور عالمي. من خلال المحتوى المقنع والشراكات الاستراتيجية، نربط مصر بالمجتمع الدولي.',
                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: masrwael3alm, title: 'مصر و العالم'}],
                    pdf: null
                },
                {
                    title: 'مشروع مهن الأنبياء',
                    description: 'تقديم استشارات وتطوير لأكثر من 850 شركة في مختلف المجالات.',
                    category: '',
                    image: mehanalanbiaa,
                    details: 'مشروع تعليمي إعلامي فريد يستكشف المهن والمهارات المختلفة المنسوبة إلى الأنبياء في التقاليد الإسلامية. يجمع هذا المشروع بين التعليم الديني والتوجيه المهني العملي والإلهام.',
                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: mehanalanbiaa, title: 'مهن الأنبياء'}],
                    pdf: null
                },

                {
                    title: 'مشروع نهضة مصر',
                    description: 'تقديم استشارات وتطوير لأكثر من 850 شركة في مختلف المجالات.',
                    category: '',
                    image: nahdetmasr,
                    details: 'نهضة مصر هو مشروع تطوير شامل يركز على تمكين الشركات والمؤسسات المصرية. من خلال الاستشارات الاستراتيجية والحلول المبتكرة، نساعد المنظمات على تحقيق النمو المستدام والنجاح.',
                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: nahdetmasr, title: 'نهضة مصر'}],
                    pdf: null
                },
                {
                    title: 'مشورع يد يحبها الله و رسوله',
                    description: 'تقديم استشارات وتطوير لأكثر من 850 شركة في مختلف المجالات.',
                    category: '',
                    image: hand,
                    details: 'يركز هذا المشروع الملهم على العمل الخيري وخدمة المجتمع، مسلطاً الضوء على أهمية مساعدة الآخرين كما هو مؤكد في التعاليم الإسلامية. يجمع بين الإنتاج الإعلامي ومبادرات التأثير الاجتماعي.',
                    copyright: 'دكتور/ أدهم الشرقاوي هو صاحب الملكية الفكرية والأدبية لهذا المشروع ولا يجوز لأحد استخدام هذه الدراسة أو اقتباس جزء منها بالنقل أو التصوير أو التحميل أو تغيير محتواها إلا بإذن من صاحب الحق الحصري لها وهو الدكتور أدهم الشرقاوي كتابيًا وإلا تعرض صاحب هذا الانتهاك إلى المساءلة القانونية.',
                    canOpenDetails: false,
                    videos: [],
                    images: [{src: hand, title: 'يد يحبها الله و رسوله'}],
                    pdf: null
                },
            ],
        },
        // Partners Section
        partners: {
            title: 'شركاء النجاح',
            subtitle: 'شكرا لكل من خطى معي خطوة نحو النجاح',
            items: [
                {
                    title: 'دكتور أدهم الشرقاوي في دورة صناعة الإعلامي الناجح',
                    description: 'إحدى دورات مركز بنان للتدريب الإعلامي بالتعاون مع قناة الناس الفضائية.',
                },
                {
                    title: 'الإعلامي يوسف الحسيني في دورة كيف تصبح مذيع ناجح؟',
                    description: 'دكتور أدهم الشرقاوي مع الإعلامي والمذيع يوسف الحسيني مقدم برنامج التاسعة.',
                },
                {
                    title: 'المهندس جاسر خورشيد في دورة كيف تصبح مهندس صوت ناجح؟',
                    description: 'دكتور أدهم الشرقاوي مع المهندس جاسر خورشيد أشهر مهندسي الصوت المصريين.',
                },
                {
                    title: 'الأستاذ نادر خليفة في دورة كيف تصبح معد برامج ناجح؟',
                    description: 'دكتور أدهم الشرقاوي مع الأستاذ نادر خليفة المؤلف والناقد الفني وكاتب السيناريو.',
                },
                {
                    title: 'المخرج الأستاذ محمد دنيا في دورة كيف تصبح مخرج ناجح؟',
                    description: 'قدم الكثير من الأعمال التلفزيونية المشهورة ومن أبرزها برنامج هذا المساء.',
                },
                {
                    title: 'الصحفي والكاتب الكبير أستاذ سمير الجمل',
                    description: 'دكتور أدهم الشرقاوي مع الصحفي والكاتب الكبير أستاذ سمير الجمل مؤلف فيلم لصوص 5 نجوم.',
                },
                {
                    title: 'دكتور أدهم الشرقاوي مع اللواء محافظ الإسكندرية طارق مهدي',
                    description: 'يوقع بروتوكول تعاون لتسويق مشروعات المحافظة من خلال برنامج مزادات.',
                },
                {
                    title: 'دكتور أدهم الشرقاوي مع الوزير محافظ البحيرة مصطفى هدهود',
                    description: 'توقيع بروتوكول تعاون لتسويق مشروعات المحافظة من خلال برنامج مزادات.',
                },
                {
                    title: 'حديث عن طرح المزادات بنظام حق الانتفاع',
                    description: 'طرح المزادات بنظام حق الانتفاع يحقق عائدا اقتصاديا كبيرا.',
                },
            ],
        },
        // Videos Section
        videos: {
            name: 'دكتور ادهم الشرقاوي',
            subtitle: 'فيديوهات - برامج - دورات',
            items: [
                {
                    id: 'eklsLyv3sUc',
                    title: 'دكتور / أدهم الشرقاوي صاحب فكرة برنامج مزادات و مدير المشروع يتحدث عن تفعيل المشروع مع اللواء طارق مهدي محافظ الإسكندرية'
                },
                {
                    id: '9QAPz42Du_0',
                    title: 'دكتور / أدهم الشرقاوي صاحب فكرة برنامج مزادات و مدير المشروع يتحدث عن توقيع بروتوكول تعاون مع اللواء مصطفٍي هدهود محافظ البحيرة'
                },
                {
                    id: 'pYaVMrI69Yc',
                    title: 'نشرة مزادات :دكتور أدهم الشرقاوي صاحب فكرة مشروع مزادات و مدير المشروع و مراسم توقيع بروتوكول تعاون مع محافظ الإسكندرية'
                },
                {
                    id: 'twMJxdxKsp4',
                    title: 'نشرة متنوعة عن المزادات و دكتور أدهم الشرقاوي صاحب فكرة برنامج مزادات و مدير المشروع يوقع بروتوكول تعاون مع محافظة البحيرة'
                },
                {
                    id: 'WhdrABmvv1w',
                    title: 'دكتور / أدهم الشرقاوي صاحب فكرة برنامج مزادات و مدير المشروع يتحدث عن البروتوكول الموقع مع محافظة الإسكندرية لا يقتصر علي التسويق فقط إنما يمتد الي المتابعة'
                },
                {
                    id: 'RdQ8c-B2XB8',
                    title: 'دكتور / أدهم الشرقاوي يتحدث عن اهداف مشروع مزادات و كيفية الإستفادة من المشروع بالنسبة للمؤسسات و الأفراد و كيفية استفادة الاقتصاد القومي منه'
                },
                {
                    id: 'oKvHFoMNYcU',
                    title: 'دكتور / أدهم الشرقاوي صاحب فكرة برنامج مزادات و مدير المشروع يتحدث عن مشروع مزادات'
                },
                {
                    id: '_KbFgwCBU-Y',
                    title: 'دكتور / أدهم الشرقاوي صاحب فكرة برنامج مزادات و مدير المشروع يرد علي استفسارات المشاهدين حول مشروع مزادات و كيفية الاستفادة منه'
                },
                {
                    id: 'DTRretawS5A',
                    title: 'دكتور / أدهم الشرقاوي صاحب فكرة برنامج مزادات و مدير المشروع يتحدث عن التنسيق مع محافظة الإسكندرية لتصوير جميع مزاداتها '
                },
                {
                    id: 'gYYh_0v_-ZI',
                    title: 'دكتور / أدهم الشرقاوي صاحب فكرة برنامج مزادات و مدير المشروع يتحدث عن مجموعة من المزادات المستفيدة من برنامج مزادات مع مجموعة من الخبراء المثمنين'
                },
                {
                    id: 'iuPtbv0XLC8',
                    title: 'دكتور / أدهم الشرقاوي صاحب فكرة برنامج مزادات و مدير المشروع يتحدث عن تفعيل مشروع مزادات مع محافظة البحيرة قريبًا'
                },
                {
                    id: 'ojJmI-bvhIA',
                    title: 'دكتور / أدهم الشرقاوي صاحب فكرة برنامج مزادات و مدير المشروع يتحدث عن تقييم مشروع مزادات منذ بدايته و المشاكل و المميزات'
                },
                {
                    id: 'ag_sP1sOwik',
                    title: 'دكتور / أدهم الشرقاوي صاحب فكرة برنامج مزادات و مدير المشروع يتحدث عن الخطة المستقبلية لمشروع مزادات'
                },
                {id: 'fmKqntOVqPw', title: 'شرح مختصر لفكرة النادي العقاري المشروع الأول من نوعه علي مستوي العالم'},
            ],
        },
        // Contact Section
        contact: {
            title: 'تواصل معنا',
            subtitle: 'اتصل بنا فى اى وقت وسنقوم بالتواصل معك فى اقرب فرصة',
            form: {
                name: 'الاسم*',
                email: 'الايميل*',
                message: 'الرسالة*',
                send: 'إرسال',
            },
            address: 'العنوان',
            addressValue: 'A1-210 / kazan plaza / gamal abdelnaser .ST / 6 october - Giza',
            emailLabel: 'البريد الإلكتروني',
            emailValue: 'info@adhamelsharkawy.com',
            website: 'الموقع الإلكتروني',
            websiteValue: 'www.adhamelsharkawy.com',
            successMessage: 'شكراً لتواصلك معنا! سنرد عليك قريباً.',
        },
        // Footer
        footer: {
            home: 'الصفحة الرئيسية',
            services: 'خدماتنا',
            works: 'أعمالنا',
            partners: 'شركاء النجاح',
            contact: 'اتصل بنا',
            rights: 'جميع الحقوق محفوظة © 2026 - دكتور أدهم الشرقاوي',
        },
        // Social Media
        socialMedia: {
            facebook: 'https://www.facebook.com/dr.adhamelsharkaawy/',
            twitter: 'https://x.com/dradhambis',
            instagram: 'https://www.instagram.com/dr.adhamelsharkawy/',
            linkedin: 'https://www.linkedin.com/in/dr-adhamelsharkawy?utm_source=share_via&utm_content=profile&utm_medium=member_android',
            youtube: 'https://www.youtube.com/@adhamelsharkaawy',
            whatsapp: 'https://wa.me/+201004449782',
        },
    },
};

export const LanguageProvider = ({children}) => {
    const [language, setLanguage] = useState('en');

    const toggleLanguage = () => {
        setLanguage(prev => prev === 'en' ? 'ar' : 'en');
    };

    const t = translations[language];
    const isRTL = language === 'ar';

    return (
        <LanguageContext.Provider value={{language, toggleLanguage, t, isRTL}}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

